/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions

==========================================================================================*/

import categoryGQL from "@/http/requests/cbs/category_gql";
import requestv2GQL from "@/http/requests/request/request_v2_gql";
import departmentGQL from "@/http/requests/card/department_gql.js";
import address from "@/http/requests/card/address_gql.js";
import tagGql from "@/http/requests/link/tag_gql.js";

const actions = {
	// /////////////////////////////////////////////
	// COMPONENTS
	// /////////////////////////////////////////////

	// Vertical NavMenu
	updateVerticalNavMenuWidth({ commit }, width) {
		commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width);
	},

	// VxAutoSuggest
	updateStarredPage({ commit }, payload) {
		commit("UPDATE_STARRED_PAGE", payload);
	},

	// The Navbar
	arrangeStarredPagesLimited({ commit }, list) {
		commit("ARRANGE_STARRED_PAGES_LIMITED", list);
	},
	arrangeStarredPagesMore({ commit }, list) {
		commit("ARRANGE_STARRED_PAGES_MORE", list);
	},

	// /////////////////////////////////////////////
	// UI
	// /////////////////////////////////////////////

	toggleContentOverlay({ commit }) {
		commit("TOGGLE_CONTENT_OVERLAY");
	},
	updateTheme({ commit }, val) {
		commit("UPDATE_THEME", val);
	},

	// /////////////////////////////////////////////
	// User/Account
	// /////////////////////////////////////////////

	updateUserInfo({ commit }, payload) {
		commit("UPDATE_USER_INFO", payload);
	},
	updateUserRole({ dispatch }, payload) {
		// Change client side
		payload.aclChangeRole(payload.userRole);

		// Make API call to server for changing role

		// Change userInfo in localStorage and store
		dispatch("updateUserInfo", { userRole: payload.userRole });
	},

	resetStore({ commit }) {
		commit("RESET_STORE");
	},

	fetchRequestTypes({ commit }, payload = {}) {
		return new Promise((resolve, reject) => {
			requestv2GQL
				.getRequestTypes(payload)
				.then(response => {
					commit("SET_REQUEST_TYPES", response.data);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchCategories({ commit }, payload) {
		return new Promise((resolve, reject) => {
			categoryGQL
				.fetchCategories(payload)
				.then(response => {
					commit("SET_CATEGORIES", response.categories);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchDepartments({ commit }, payload) {
		return new Promise((resolve, reject) => {
			departmentGQL
				.fetchDepartments(payload)
				.then(response => {
					commit("SET_DEPARTMENTS", response.departments);
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},

	fetchStates({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				address
					.fetchStates(payload)
					.then(response => {
						commit("UPDATE_STATES", response.states);
						resolve(response.states);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchProvince]", error);
		}
	},
	fetchDistricts({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				address
					.fetchDistricts(payload)
					.then(response => {
						commit("UPDATE_DISTRICTS", response.districts);
						resolve(response.districts);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[fetchDistrict]", error);
		}
	},
	fetchWards({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				address
					.fetchWards(payload)
					.then(response => {
						commit("UPDATE_WARDS", response.wards);
						resolve(response.wards);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[getWard]", error);
		}
	},
	fetchSetSystemTags({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				tagGql
					.fetchTags(payload)
					.then(response => {
						commit("SET_SYSTEM_TAGS", response.tags);
						resolve(response.tags);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[SET_SYSTEM_TAGS]", error);
		}
	},
	updateSystemTag({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				tagGql
					.updateTag(payload)
					.then(response => {
						commit("UPDATE_SYSTEM_TAG", response);
						resolve(response);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[UPDATE_SYSTEM_TAG]", error);
		}
	},
	addSystemTag({ commit }, payload) {
		try {
			return new Promise((resolve, reject) => {
				tagGql
					.addTag(payload)
					.then(response => {
						commit("ADD_SYSTEM_TAG", response);
						resolve(response);
					})
					.catch(error => {
						reject(error);
					});
			});
		} catch (error) {
			console.error("[ADD_SYSTEM_TAG]", error);
		}
	}
};

export default actions;
